// This file is generated by pnpm icons:generate. Do not edit.

import {StarterPack_Stroke2_Corner0_Rounded as CanonicalStarterPack_Stroke2_Corner0_Rounded} from '../StarterPack'

/** @deprecated Import StarterPack_Stroke2_Corner0_Rounded from `#/components/icons/StarterPack` instead. */
export const StarterPack_Stroke2_Corner0_Rounded =
  CanonicalStarterPack_Stroke2_Corner0_Rounded
